// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"f753b1ad","913":"c3afd34e"}[chunkId] + ".chunk.css";
};